import { toast } from "sonner";
import { Star, MessageCircle, Mail, Copy, BadgeCheck } from "lucide-react";
import { waLink, AZIENDA } from "@/lib/config";

export const RichiediRecensione = ({ it }) => {
  if (it.stato === "annullato") return null;
  if (it.recensito) return (
    <p className="flex items-center gap-1.5 text-sm font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg p-3" data-testid="dettaglio-recensito">
      <BadgeCheck className="w-4 h-4" /> Il cliente ha già lasciato la recensione
    </p>
  );
  const url = `${window.location.origin}/recensione/${it.review_token}`;
  const msg = `Gentile ${it.nome}, grazie per averci scelto. Ci lascerebbe una recensione sull'intervento? ${url} - ${AZIENDA.nome}`;
  const copia = () => navigator.clipboard.writeText(url).then(() => toast.success("Link copiato"));
  const btn = "h-10 inline-flex items-center justify-center gap-1.5 rounded-lg text-xs font-bold transition-colors";

  return (
    <div className="space-y-2 rounded-xl border border-amber-200 bg-amber-50 p-3" data-testid="richiedi-recensione-box">
      <p className="flex items-center gap-1.5 text-sm font-semibold"><Star className="w-4 h-4 fill-amber-400 text-amber-400" /> Link recensione di questo cliente</p>
      {it.stato !== "completato" && (
        <p className="text-xs text-amber-800" data-testid="recensione-link-in-attesa">
          Il link è già abbinato al cliente: potrà recensire appena segni l'intervento come Completato.
          {it.email ? ` In quel momento gli arriverà in automatico via email (${it.email}).` : " Il cliente non ha email: invialo su WhatsApp."}
        </p>
      )}
      {it.promemoria_recensione_at && (
        <p className="text-xs font-semibold text-emerald-700" data-testid="recensione-promemoria-inviato">
          Email con il link inviata in automatico il {new Date(it.promemoria_recensione_at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}
        </p>
      )}
      <div className="grid grid-cols-3 gap-2">
        <a href={waLink(it.telefono, msg)} target="_blank" rel="noreferrer" className={`${btn} bg-green-600 text-white hover:bg-green-700`} data-testid="recensione-invia-whatsapp"><MessageCircle className="w-4 h-4" /> WhatsApp</a>
        {it.email ? (
          <a href={`mailto:${it.email}?subject=${encodeURIComponent("La tua opinione sull'intervento")}&body=${encodeURIComponent(msg)}`} className={`${btn} bg-sky-600 text-white hover:bg-sky-700`} data-testid="recensione-invia-email"><Mail className="w-4 h-4" /> Email</a>
        ) : <span className={`${btn} bg-slate-100 text-slate-400`}><Mail className="w-4 h-4" /> No email</span>}
        <button onClick={copia} className={`${btn} bg-white border border-slate-200 hover:border-slate-400`} data-testid="recensione-copia-link"><Copy className="w-4 h-4" /> Copia link</button>
      </div>
    </div>
  );
};
